import { useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { deleteWithToken, getLocalStorage, getWithToken, patchAvtarWithToken, patchWithToken } from '../API/Api';
import Loader from '../components/Loader';
import { MdContentCopy } from 'react-icons/md';
import { AiOutlineCheck } from 'react-icons/ai';
import { RiCloseCircleLine } from 'react-icons/ri';
import WidgetChatbot from '../Pages/widgets/chatbot/WidgetChatbot';
import UPLOAD_ICON from '../assets/icons/ComniqaiIcon-V2.0/upload-icon.svg';
import SAVE_ICON from '../assets/icons/ComniqaiIcon-V3.0/save-icon.svg';
import INFO_ICON from '../assets/icons/ComniqaiIcon-V2.0/Info-Icon.svg';
import WIDGET_ICON from '../assets/icons/ComniqaiIcon-V3.0/widget-activeicon.svg';
import APPEARANCE_ACTIVEICON from '../assets/icons/ComniqaiIcon-V3.0/appearance-activeicon.svg';
import APPEARANCE_DEACTIVEICON from '../assets/icons/ComniqaiIcon-V3.0/appearance-deactiveicon.svg';
import EMBED_ACTIVEICON from '../assets/icons/ComniqaiIcon-V3.0/embed-activeicon.svg';
import EMBED_DEACTIVEICON from '../assets/icons/ComniqaiIcon-V3.0/embed-deactiveicon.svg';
import STARTED_ICON from '../assets/icons/ComniqaiIcon-V3.0/started-icon.svg';
import HEADERPART_ICON from '../assets/icons/ComniqaiIcon-V3.0/headerpart-icon.svg';
import WINDOW_ICON from '../assets/icons/ComniqaiIcon-V3.0/window-icon.svg';
import BUBBLESPART_ICON from '../assets/icons/ComniqaiIcon-V3.0/bubblespart-icon.svg';
import GENERAL_ACTIVEICON from '../assets/icons/ComniqaiIcon-V3.0/general-activeicon.svg';
import GENERAL_DEACTIVEICON from '../assets/icons/ComniqaiIcon-V3.0/general-deactiveicon.svg';
import BUBBLES_ACTIVEICON from '../assets/icons/ComniqaiIcon-V3.0/bubbles-activeicon.svg';
import BUBBLES_DEACTIVEICON from '../assets/icons/ComniqaiIcon-V3.0/bubbles-deactiveicon.svg';
import HEADER_ACTIVEICON from '../assets/icons/ComniqaiIcon-V3.0/header-activeicon.svg';
import HEADER_DEACTIVEICON from '../assets/icons/ComniqaiIcon-V3.0/header-deactiveicon.svg';
import WINDOW_ACTIVEICON from '../assets/icons/ComniqaiIcon-V3.0/window-activeicon.svg';
import WINDOW_DEACTIVEICON from '../assets/icons/ComniqaiIcon-V3.0/window-deactiveicon.svg';
import SHOW_BUBBLEICON from '../assets/icons/ComniqaiIcon-V3.0/show-bubble-icon.svg';
import SLIDE_TIMER_ICON from '../assets/icons/ComniqaiIcon-V3.0/slide-timer-icon.svg';
import WEBSITE_PREVIEW_ICON from '../assets/icons/ComniqaiIcon-V3.0/website-preview-icon.svg';
import { FiUpload } from 'react-icons/fi';
import SubContext from '../contexts/SubContext';
import { useWidgetContext } from '../contexts/WidgetContext';
import { getPlanLevel, PLAN_LEVELS } from '../API/Constant';

const CustomizeWidget = () => {
  const Navigate = useNavigate();
  const { state } = useLocation();
  const { setHasUnsavedChanges, setUpdateFn } = useWidgetContext();

  const [avatarPreview, setAvatarPreview] = useState('');
  const [bgPreview, setBgPreview] = useState('');
  const [widgetCode, setWidgetCode] = useState('');
  const [copySuccess, setCopySuccess] = useState(false);
  const [copyLeadSuccess, setCopyLeadSuccess] = useState(false);
  const [bgPopup, setBgPopup] = useState(false);
  const [apiTokenData, setApiTokenData] = useState('');
  const [loader, setLoader] = useState(false);
  const [companyData, setCompanyData] = useState('');
  const [logoPreview, setLogoPreview] = useState('');
  const [faqPopup, setFaqPopup] = useState(false);
  const subsFlag = useContext(SubContext);

  const subscriptionInfo = subsFlag?.subscriptionFlag?.user?.subscription ?? null;
  const subscriptionName = subscriptionInfo?.name ?? 'Free';
  const planLevel = useMemo(() => getPlanLevel(subscriptionName), [subscriptionName]);
  const isFreePlan = planLevel === PLAN_LEVELS.Free;

  const [showWarning, setShowWarning] = useState(false);
  const [activeTab, setActiveTab] = useState('appearance');
  const [activeChildTab, setActiveChildTab] = useState('General');
  const [widgetValues, setWidgetValues] = useState({
    id: '',
    chat_name: '',
    heading: '',
    sub_heading: '',
    chat_status: '',
    buble_active_status: '',
    color: '',
    chatbot_avtar: '',
    chatbot_logo_size: '',
    chatbot_logo: '',
    company: '',
    launcher_icon: '',
    default_launcher_icon: '',
    popup_status: '',
    timer_count: 0,
    buble_timer_count: 0,
    background_color: '',
    client_bubble_color: '',
    website: '',
    bg_chatbot: '',
    text_color: '',
    bubble_text_color: '',
    agent_bubble_text_color: '',
    is_script_ingrate: null,
    header_logo_size: '',
    heading_font_size: '',
    bubble_avatar_size: '',
    agent_bubble_font_size: '',
    user_bubble_font_size: '',
    windo_font_size: '',
    chat_bubble_icon_size: '',
    chatbot_slider_size: '',
    bubble_width: '',
    bubble_height: '',
    bubble_button_height: '',
    bubble_button_width: '',
    bubble_text_size: '',
    text_color_bubble: '',
    bubble_bg_color: '',
    inside_bubble_width: '',
    inside_bubble_height: '',
    inside_bubble_button_width: '',
    inside_bubble_button_height: '',
    inside_bubble_text_size: '',
    inside_text_color_bubble: '',
    cbubble_bg_color: '',
    chatbot_position: 'bottom-right',
    chat_input_bgcolor: '',
    chat_input_fontsize: '',
    chat_input_icon_color: '',
    heading_font_color: '',
    chat_input_font_color: '',
    btn_primary_bg: '',
    btn_primary_text: '',
    btn_secondary_bg: '',
    btn_secondary_text: '',
    inside_btn_primary_bg: '',
    inside_btn_primary_text: '',
    inside_btn_secondary_bg: '',
    inside_btn_secondary_text: '',
  });
  const [refreshTrigger, setRefreshTrigger] = useState(false);

  const [showPublishPopup, setShowPublishPopup] = useState(false);
  const [isPublishing, setIsPublishing] = useState(false);

  const [imgUrlPath, setImgUrlPath] = useState({
    id: '1',
    link: '',
    status: '',
  });
  const {
    chat_name,
    heading,
    sub_heading,
    chatbot_logo,
    chatbot_logo_size,
    company,
    color,
    chatbot_avtar,
    launcher_icon,
    default_launcher_icon,
    chat_status,
    buble_active_status,
    popup_status,
    timer_count,
    buble_timer_count,
    launcher_icon_status,
    client_bubble_color,
    website,
    background_color,
    bg_chatbot,
    text_color,
    bubble_text_color,
    agent_bubble_text_color,
    is_script_ingrate,
    header_logo_size,
    heading_font_size,
    bubble_avatar_size,
    agent_bubble_font_size,
    user_bubble_font_size,
    windo_font_size,
    chat_bubble_icon_size,
    chatbot_slider_size,
    bubble_width,
    bubble_height,
    bubble_button_height,
    bubble_button_width,
    bubble_text_size,
    text_color_bubble,
    bubble_bg_color,
    inside_bubble_width,
    inside_bubble_height,
    inside_bubble_button_width,
    inside_bubble_button_height,
    inside_bubble_text_size,
    inside_text_color_bubble,
    inside_bubble_bg_color,
    chatbot_position,
    chat_input_bgcolor,
    chat_input_fontsize,
    chat_input_icon_color,
    heading_font_color,
    chat_input_font_color,
    btn_primary_bg,
    btn_primary_text,
    btn_secondary_bg,
    btn_secondary_text,
    inside_btn_primary_bg,
    inside_btn_primary_text,
    inside_btn_secondary_bg,
    inside_btn_secondary_text,
  } = widgetValues;

  useEffect(() => {
    window.scrollTo(0, 0);
    let token = getLocalStorage('apiToken');
    if (token) {
      setApiTokenData(JSON.parse(token));
      getWidgetDetails(JSON.parse(token));
      getScriptCode(JSON.parse(token));
      getBotDetails(JSON.parse(token));
    } else {
      Navigate('/login');
    }
  }, []);

  const getBotDetails = (token) => {
    setLoader(true);
    getWithToken('company/', token)
      .then((response) => {
        if (response.status === 201) {
          setCompanyData(response.data);
        }
      })
      .catch((error) => {
        console.error('error: ', error);
      })
      .finally(() => {
        setLoader(false);
      });
  };

  const LauncherIconChange = (image, index) => {
    const updatedIcons = default_launcher_icon.map((icon, i) => {
      if (i === index) {
        return {
          ...icon,
          status: true,
        };
      } else {
        return {
          ...icon,
          status: false,
        };
      }
    });
    setWidgetValues((prevValues) => ({
      ...prevValues,
      default_launcher_icon: updatedIcons,
    }));

    setImgUrlPath({
      id: index + 1,
      link: image.link,
      status: updatedIcons[index].status,
    });

    setHasUnsavedChanges(true);
  };

  const userHandleChange = async (e) => {
    const { name, files, value } = e.target;
    if (files) {
      const file = files[0];
      setWidgetValues({ ...widgetValues, [name]: file });
      const reader = new FileReader();
      reader.onload = () => {
        setAvatarPreview(reader.result);
      };
      reader.readAsDataURL(file);

      let fd = new FormData();
      fd.append('chatbot_avtar', file);

      try {
        const response = await patchAvtarWithToken('Avtar_Image_WidgetAPI/', apiTokenData, fd);
        if (response.status === 200) {
          toast.success(response.message);
          getWidgetDetails(apiTokenData);
        } else {
          toast.error(response.message);
        }
      } catch (error) {
        console.error(error);
      }
    } else {
      const updated = {
        ...widgetValues,
        [name]: value || '',
      };

      setWidgetValues(updated);
      setHasUnsavedChanges(true);
    }
  };

  const logoIconHandleChange = async (e) => {
    if (e.target.files) {
      const file = e.target.files[0];
      setWidgetValues({ ...widgetValues, [e.target.name]: file });
      const reader = new FileReader();
      reader.onload = () => {
        setLogoPreview(reader.result);
      };
      reader.readAsDataURL(file);

      let fd = new FormData();
      fd.append('chatbot_logo', file);
      try {
        const response = await patchAvtarWithToken('Logo_Image_WidgetAPI/', apiTokenData, fd);
        if (response.status === 200) {
          toast.success(response.message);
          getWidgetDetails(apiTokenData);
        } else {
          toast.error(response.message);
        }
      } catch (error) {
        console.error(error);
      }
    }
  };

  const getWidgetDetails = (token) => {
    setLoader(true);
    getWithToken('Webchat_widgetAPI/', token)
      .then((response) => {
        if (response.status === 200) {
          setWidgetValues({
            id: response?.data?.id,
            chat_name: response?.data?.name,
            heading: response?.data?.heading,
            chatbot_logo: response?.data?.chatbot_logo,
            chatbot_logo_size: response?.data?.chatbot_logo_size,
            sub_heading: response?.data?.sub_heading,
            chat_status: response?.data?.status,
            buble_active_status: response?.data?.buble_active_status,
            color: response?.data?.color,
            default_launcher_icon: response?.data?.default_launcher_icon,
            chatbot_avtar: response?.data?.chatbot_avtar,
            launcher_icon: response?.data?.launcher_icon,
            company: response?.data?.company,
            popup_status: response?.data?.popup_status,
            launcher_icon_status: response?.data?.launcher_icon_status,
            timer_count: response?.data?.timer_count,
            buble_timer_count: response?.data?.buble_timer_count,
            background_color: response?.data?.background_color,
            bg_chatbot: response?.data?.bg_chatbot,
            client_bubble_color: response?.data?.client_bubble_color,
            website: response?.data?.website,
            text_color: response?.data?.text_color,
            bubble_text_color: response?.data?.bubble_text_color,
            agent_bubble_text_color: response?.data?.agent_bubble_text_color,
            is_script_ingrate: response?.data?.is_script_ingrate,
            header_logo_size: response?.data?.header_logo_size,
            heading_font_size: response?.data?.heading_font_size,
            bubble_avatar_size: response?.data?.bubble_avatar_size,
            agent_bubble_font_size: response?.data?.agent_bubble_font_size,
            user_bubble_font_size: response?.data?.user_bubble_font_size,
            windo_font_size: response?.data?.windo_font_size,
            chat_bubble_icon_size: response?.data?.chat_bubble_icon_size,
            chatbot_slider_size: response?.data?.chatbot_slider_size,
            bubble_width: response?.data?.bubble_width,
            bubble_height: response?.data?.bubble_height,
            bubble_button_height: response?.data?.bubble_button_height,
            bubble_button_width: response?.data?.bubble_button_width,
            bubble_text_size: response?.data?.bubble_text_size,
            text_color_bubble: response?.data?.text_color_bubble,
            bubble_bg_color: response?.data?.bubble_bg_color,
            inside_bubble_width: response?.data?.inside_bubble_width,
            inside_bubble_height: response?.data?.inside_bubble_height,
            inside_bubble_button_width: response?.data?.inside_bubble_button_width,
            inside_bubble_button_height: response?.data?.inside_bubble_button_height,
            inside_bubble_text_size: response?.data?.inside_bubble_text_size,
            inside_text_color_bubble: response?.data?.inside_text_color_bubble,
            inside_bubble_bg_color: response?.data?.inside_bubble_bg_color,
            chatbot_position: response?.data?.chatbot_position || 'bottom-right',
            chat_input_bgcolor: response?.data?.chat_input_bgcolor || '',
            chat_input_fontsize: response?.data?.chat_input_fontsize || '',
            chat_input_icon_color: response?.data?.chat_input_icon_color || '',
            heading_font_color: response?.data?.heading_font_color || '',
            chat_input_font_color: response?.data?.chat_input_font_color || '',
            btn_primary_bg: response?.data?.btn_primary_bg || '',
            btn_primary_text: response?.data?.btn_primary_text || '',
            btn_secondary_bg: response?.data?.btn_secondary_bg || '',
            btn_secondary_text: response?.data?.btn_secondary_text || '',
            inside_btn_primary_bg: response?.data?.inside_btn_primary_bg || '',
            inside_btn_primary_text: response?.data?.inside_btn_primary_text || '',
            inside_btn_secondary_bg: response?.data?.inside_btn_secondary_bg || '',
            inside_btn_secondary_text: response?.data?.inside_btn_secondary_text || '',
          });
          if (response?.data?.launcher_icon_status) {
            setImgUrlPath({
              id: '',
              link: response.data.launcher_icon,
            });
          } else {
            response?.data?.default_launcher_icon.map((data, index) => {
              if (data.status) {
                setImgUrlPath({
                  id: index + 1,
                  link: data.link,
                });
              }
            });
          }
          setLoader(false);
        } else {
          setLoader(false);
        }
      })
      .catch((error) => {
        // toast.error('Something went wrong');
        setLoader(false);
      });
  };

  const getScriptCode = (token) => {
    getWithToken('Copy_WidgetAPI/', token)
      .then((response) => {
        const textToCopy = `<script src="${response.data.js_script_file}"></script>
      <script src="https://api.comniqai.com/media/logo/Widget.js"></script>`;
        setWidgetCode(textToCopy);
      })
      .catch((error) => {
        // toast.error('Something went wrong');
      });
  };

  const UpdateChatBotData = useCallback(
    async (e, keyName, value) => {
      if (state != null && state?.faqFlag) {
        setFaqPopup(true);
      }
      e.preventDefault();

      let fd = new FormData();
      fd.append('default_launcher_icon', imgUrlPath?.id);
      fd.append('name', chat_name);
      fd.append('heading', heading);
      fd.append('sub_heading', sub_heading);
      fd.append('status', keyName === 'chat_status' ? !chat_status : chat_status);
      fd.append('buble_active_status', keyName === 'buble_active_status' ? !buble_active_status : buble_active_status);
      fd.append('color', color);
      fd.append('popup_status', keyName === 'popup_status' ? !popup_status : popup_status);
      fd.append('timer_count', timer_count);
      fd.append('buble_timer_count', buble_timer_count);
      fd.append('background_color', background_color);
      fd.append('client_bubble_color', client_bubble_color);
      fd.append('website', website);
      fd.append('text_color', text_color);
      fd.append('bubble_text_color', bubble_text_color);
      fd.append('agent_bubble_text_color', agent_bubble_text_color);
      fd.append('chatbot_logo_size', chatbot_logo_size);
      fd.append('is_script_ingrate', keyName === 'is_script_ingrate' ? value : is_script_ingrate);
      fd.append('header_logo_size', header_logo_size);
      fd.append('heading_font_size', heading_font_size);
      fd.append('bubble_avatar_size', bubble_avatar_size);
      fd.append('agent_bubble_font_size', agent_bubble_font_size);
      fd.append('user_bubble_font_size', user_bubble_font_size);
      fd.append('windo_font_size', windo_font_size);
      fd.append('chat_bubble_icon_size', chat_bubble_icon_size);
      fd.append('chatbot_slider_size', chatbot_slider_size);
      fd.append('bubble_width', bubble_width);
      fd.append('bubble_height', bubble_height);
      fd.append('bubble_button_height', bubble_button_height);
      fd.append('bubble_button_width', bubble_button_width);
      fd.append('bubble_text_size', bubble_text_size);
      fd.append('text_color_bubble', text_color_bubble);
      fd.append('bubble_bg_color', bubble_bg_color);
      fd.append('inside_bubble_width', inside_bubble_width);
      fd.append('inside_bubble_height', inside_bubble_height);
      fd.append('inside_bubble_button_width', inside_bubble_button_width);
      fd.append('inside_bubble_button_height', inside_bubble_button_height);
      fd.append('inside_bubble_text_size', inside_bubble_text_size);
      fd.append('inside_text_color_bubble', inside_text_color_bubble);
      fd.append('inside_bubble_bg_color', inside_bubble_bg_color);
      fd.append('chatbot_position', chatbot_position);
      fd.append('chat_input_bgcolor', chat_input_bgcolor);
      fd.append('chat_input_fontsize', chat_input_fontsize);
      fd.append('chat_input_icon_color', chat_input_icon_color);
      fd.append('heading_font_color', heading_font_color);
      fd.append('chat_input_font_color', chat_input_font_color);
      fd.append('btn_primary_bg', btn_primary_bg);
      fd.append('btn_primary_text', btn_primary_text);
      fd.append('btn_secondary_bg', btn_secondary_bg);
      fd.append('btn_secondary_text', btn_secondary_text);
      fd.append('inside_btn_primary_bg', inside_btn_primary_bg);
      fd.append('inside_btn_primary_text', inside_btn_primary_text);
      fd.append('inside_btn_secondary_bg', inside_btn_secondary_bg);
      fd.append('inside_btn_secondary_text', inside_btn_secondary_text);

      patchAvtarWithToken('Webchat_widgetAPI/', apiTokenData, fd)
        .then((response) => {
          if (response.status === 200) {
            toast.dismiss();
            toast.success(response.message);
            setRefreshTrigger((prev) => !prev);
            getWidgetDetails(apiTokenData);
            scriptCode(apiTokenData);
            setHasUnsavedChanges(false);
            setShowPublishPopup(true);
          } else {
            toast.error(response.message);
          }
        })
        .catch((error) => {
          console.error('Error occurred:', error);
          toast.error('An error occurred while updating chat bot data');
        });
    },
    [widgetValues, apiTokenData, setHasUnsavedChanges]
  );

  useEffect(() => {
    setUpdateFn(() => (e, keyName, value) => UpdateChatBotData(e, keyName, value));
  }, [apiTokenData, setUpdateFn, UpdateChatBotData]);

  const handleCopyText = () => {
    const tempInput = document.createElement('textarea');
    tempInput.value = widgetCode;
    document.body.appendChild(tempInput);
    tempInput.select();
    document.execCommand('copy');
    document.body.removeChild(tempInput);
    setCopySuccess(true);
    setTimeout(function () {
      setCopySuccess(false);
    }, 2000);
  };

  const userBgImageChange = async (e) => {
    const file = e.target.files[0];
    setWidgetValues({ ...widgetValues, [e.target.name]: file });

    // Generate a preview of the uploaded image
    const reader = new FileReader();
    reader.onload = () => {
      setBgPreview(reader.result);
    };
    reader.readAsDataURL(file);

    let fd = new FormData();
    fd.append('bg_chatbot', file);
    try {
      const response = await patchAvtarWithToken('Widget_bg_ColorAPI/', apiTokenData, fd);
      if (response.status === 200) {
        toast.success(response.message);
        getWidgetDetails(apiTokenData);
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const launcherIconHandleChange = (e) => {
    e.preventDefault();
    let fd = new FormData();
    fd.append('launcher_icon', e.target.files[0]);

    patchAvtarWithToken('Icons_Image_WidgetAPI/', apiTokenData, fd)
      .then((response) => {
        if (response.status === 200) {
          setImgUrlPath({
            id: '',
            link: response.data.launcher_icon,
            // status: false,
          });
          toast.success(response.message);
          getWidgetDetails(apiTokenData);
        } else {
          toast.error(response.message);
        }
      })
      .catch((error) => {
        console.error('error: ', error);
      });
  };

  const scriptCode = () => {
    const JS_Payload = {
      js: `const id='${widgetValues.id}';`,
    };

    patchWithToken('Copy_WidgetAPI/', apiTokenData, JS_Payload)
      .then((response) => {
        if (response.status === 200) {
          const textToCopy = `<script src="${response.data.js_script_file}"></script>
<script src="https://api.comniqai.com/media/logo/Widget.js"></script>`;
          setWidgetCode(textToCopy);
        }
      })
      .catch((error) => {
        console.error('error: ', error);
      });
  };

  const handleBgDelete = async () => {
    try {
      const response = await deleteWithToken('Widget_bg_ColorAPI/', apiTokenData);
      if (response.status === 200) {
        setBgPopup(false);
        toast.success(response.message);
        getWidgetDetails(apiTokenData);
        setBgPreview('');
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleNavigatePreview = () => {
    const data = {
      id: widgetValues.id,
      previewData: true,
      company_id: companyData?.id,
    };

    const url = '/preview';
    const params = new URLSearchParams(data);
    const fullUrl = `${url}?${params.toString()}`;

    const newWindow = window.open(fullUrl, '_blank');
    if (newWindow) {
      newWindow.opener = null;
    }
  };

  const handleShareLeadPreview = () => {
    if (!website && is_script_ingrate === 'true') {
      toast.error('Please enter a website Link');
      return;
    }
    const data = {
      id: widgetValues.id,
      previewData: true,
      company_id: companyData?.id,
      leadGenerated: true,
    };

    const url = '/preview';
    const params = new URLSearchParams(website ? (is_script_ingrate === 'true' ? { leadGenerated: true } : data) : data);
    const fullUrl = is_script_ingrate === 'true' ? `${website}?${params.toString()}` : `https://comniqai.com${url}?${params.toString()}`;

    const newWindow = window.open(fullUrl, '_blank');
    if (newWindow) {
      newWindow.opener = null;
    }
  };

  const copyToClipboard = async () => {
    if (!website && is_script_ingrate === 'true') {
      toast.error('Please enter a website Link');
      return;
    }
    const data = {
      id: widgetValues.id,
      previewData: true,
      company_id: companyData?.id,
    };
    const url = '/preview';
    const params = new URLSearchParams(data);
    const fullUrl = is_script_ingrate === 'true' ? website : `https://comniqai.com${url}?${params.toString()}`;
    try {
      await navigator.clipboard.writeText(fullUrl);
      toast.info('URL copied');
    } catch (error) {
      console.error('Failed to copy URL to clipboard:', error);
    }
  };

  const copyToLeadClipboard = async () => {
    if (!website && is_script_ingrate === 'true') {
      toast.error('Please enter a website Link');
      return;
    }
    const data = {
      id: widgetValues.id,
      previewData: true,
      company_id: companyData?.id,
      leadGenerated: true,
    };
    const url = '/preview';
    const params = new URLSearchParams(website ? (is_script_ingrate === 'true' ? { leadGenerated: true } : data) : data);
    const fullUrl = is_script_ingrate === 'true' ? `${website}?${params.toString()}` : `https://comniqai.com${url}?${params.toString()}`;

    try {
      setCopyLeadSuccess(true);
      setTimeout(function () {
        setCopyLeadSuccess(false);
      }, 2000);
      await navigator.clipboard.writeText(fullUrl);
      toast.info('URL copied');
    } catch (error) {
      console.error('Failed to copy URL to clipboard:', error);
    }
  };

  const resetChatbotWidget = () => {
    getWithToken('Webchat_widget_resetAPI/', apiTokenData)
      .then((response) => {
        toast.dismiss();
        toast.success(response.message);
        getWidgetDetails(apiTokenData);
      })
      .catch((error) => {
        console.error('error: ', error);
      });
  };

  const publishChatbotData = async (token) => {
    setIsPublishing(true);
    try {
      const response = await getWithToken('publish-data', token);
      if (response.status === 200) {
        toast.success(response?.message);
      } else {
        toast.error(response.message || 'Failed to publish chatbot');
      }
    } catch (error) {
      console.error('Error publishing chatbot:', error);
      toast.error('Something went wrong while publishing');
    } finally {
      setIsPublishing(false);
      setShowPublishPopup(false);
    }
  };

  return (
    <>
      <div className='row'>
        <div className='col-xxl-7 col-xl-7 col-lg-12 col-md-12 col-sm-12 col-12'>
          <div className='comniq-container'>
            <div className='comniq-container-box'>
              <div className='d-flex align-items-center gap-3'>
                <div className='comniq-icon-box d-flex align-items-center justify-content-center'>
                  <img src={WIDGET_ICON} alt='comniqai-logo' className='img-fluid' />
                </div>
                <div>
                  <h5 className='mb-1 outfit-bold'>Widget Customization</h5>
                  <p className='text-muted mb-0 outfit-regular'>Customize the appearance of your chatbot widget</p>
                </div>
              </div>
            </div>
            <div className='container-fluid pt-4 px-0'>
              <div className='soft-tab-wrapper d-flex p-1 w-100'>
                <button className={`soft-tab-btn gap-2 ${activeTab === 'appearance' ? 'active' : ''}`} onClick={() => setActiveTab('appearance')}>
                  <img src={activeTab === 'appearance' ? APPEARANCE_ACTIVEICON : APPEARANCE_DEACTIVEICON} alt='appearance-icon' /> Appearance
                </button>

                <button className={`soft-tab-btn gap-2 ${activeTab === 'embed' ? 'active' : ''}`} onClick={() => setActiveTab('embed')}>
                  <img src={activeTab === 'embed' ? EMBED_ACTIVEICON : EMBED_DEACTIVEICON} alt='embed-icon' /> Embed Code
                </button>
              </div>
              <div className='comniq-container my-3'>
                <span className='text-muted small outfit-regular'>
                  {activeTab === 'appearance'
                    ? 'Customize the colors, fonts, and visual elements of your chatbot widget to match your brand.'
                    : 'Get the code needed to embed your chatbot on your website and customize integration settings.'}
                </span>
              </div>

              {activeTab === 'appearance' && (
                <>
                  <div className='comniq-container-box mb-3'>
                    <h5 className='outfit-semibold color-theme-cerisePink'>Customize Your Chatbot</h5>
                    <p className='mb-0 outfit-regular'>
                      It's time to make ComniqAI visually match your brand with ease! Here you can customize the slide-out look, the timer, the bubbles, buttons, logos, and more to
                      match your brand perfectly. You can even preview and share your agents once you're done before you deploy ComniqAI onto your website. 🎉
                    </p>
                  </div>

                  <div className='comniq-container'>
                    <div className='soft-tab-wrapper d-flex p-1'>
                      <button className={`soft-tab-btn gap-2 ${activeChildTab === 'General' ? 'active' : ''}`} onClick={() => setActiveChildTab('General')}>
                        <img src={activeChildTab === 'General' ? GENERAL_ACTIVEICON : GENERAL_DEACTIVEICON} alt='general-icon' /> General
                      </button>

                      <button className={`soft-tab-btn gap-2 ${activeChildTab === 'Header' ? 'active' : ''}`} onClick={() => setActiveChildTab('Header')}>
                        <img src={activeChildTab === 'Header' ? HEADER_ACTIVEICON : HEADER_DEACTIVEICON} alt='header-icon' /> Header
                      </button>
                      <button className={`soft-tab-btn gap-2 ${activeChildTab === 'Bubbles' ? 'active' : ''}`} onClick={() => setActiveChildTab('Bubbles')}>
                        <img src={activeChildTab === 'Bubbles' ? BUBBLES_ACTIVEICON : BUBBLES_DEACTIVEICON} alt='bubbles-icon' /> Bubbles
                      </button>

                      <button className={`soft-tab-btn gap-2 ${activeChildTab === 'Window' ? 'active' : ''}`} onClick={() => setActiveChildTab('Window')}>
                        <img src={activeChildTab === 'Window' ? WINDOW_ACTIVEICON : WINDOW_DEACTIVEICON} alt='window-icon' /> Window
                      </button>
                    </div>
                    {activeChildTab === 'General' && (
                      <div className='widget-chatbot-body'>
                        <h6 className='outfit-semibold my-3 widget-body-text'>
                          <img src={STARTED_ICON} alt='started-icon' className='me-2' />
                          Get Started
                        </h6>
                        <div className='comniq-container-box d-flex align-items-center justify-content-between mb-3'>
                          <div>
                            <h5 className='outfit-semibold font14 mb-0'>Active Chatbot</h5>
                            <p className='mb-0 outfit-regular font14'>Turn the chatbot on or off</p>
                          </div>
                          <div className='form-check form-switch'>
                            <input
                              className='form-check-input'
                              type='checkbox'
                              name='chat_status'
                              checked={widgetValues.chat_status}
                              onChange={(e) => UpdateChatBotData(e, 'chat_status')}
                            />
                          </div>
                        </div>
                        <div className='row gy-3 mb-4'>
                          <div className='col-12 col-md-6'>
                            <div className='d-flex justify-content-between align-items-center flex-wrap comniq-box-shadow h-100 p-3'>
                              <div className=''>
                                <label className='widget-label outfit-medium d-flex align-items-center gap-2'>
                                  <img src={SHOW_BUBBLEICON} alt='slide-timer-icon' /> Show Popup Bubble
                                </label>
                                <div className='text-muted small'>Display chat bubble on your website</div>
                              </div>
                              <div className='form-check form-switch ms-auto'>
                                <input
                                  className='form-check-input'
                                  type='checkbox'
                                  name='buble_active_status'
                                  checked={widgetValues.buble_active_status}
                                  onChange={(e) => UpdateChatBotData(e, 'buble_active_status')}
                                />
                              </div>
                            </div>
                          </div>

                          <div className='col-12 col-md-6 chatbox-input-text'>
                            <div className='comniq-box-shadow d-flex flex-column justify-content-center chatbox-input-field  h-100 p-3'>
                              <label className='widget-label outfit-medium d-flex align-items-center gap-2'>
                                <img src={SLIDE_TIMER_ICON} alt='slide-timer-icon' /> Show Popup Bubble Timer (seconds)
                              </label>
                              <input
                                type='number'
                                className={`form-control chatbox-input box-shadow-hover ${!buble_active_status ? 'cursor-not-allowed' : ''}`}
                                name='buble_timer_count'
                                value={buble_timer_count}
                                autoComplete='off'
                                onChange={userHandleChange}
                                disabled={!buble_active_status}
                                min='0'
                              />
                            </div>
                          </div>
                        </div>
                        <div className='row gy-3 mb-4'>
                          <div className='col-12 col-md-6'>
                            <div className='d-flex justify-content-between align-items-center p-3 comniq-box-shadow h-100'>
                              <div className=''>
                                <label className='widget-label outfit-medium d-flex align-items-center gap-2'>
                                  <img src={SLIDE_TIMER_ICON} alt='slide-timer-icon' /> Show Slider
                                </label>
                                <div className='text-muted small'>Automatically slide in chat window</div>
                              </div>
                              <div className='form-check form-switch'>
                                <input
                                  className='form-check-input'
                                  type='checkbox'
                                  name='popup_status'
                                  checked={widgetValues.popup_status}
                                  onChange={(e) => UpdateChatBotData(e, 'popup_status')}
                                />
                              </div>
                            </div>
                          </div>
                          <div className='col-12 col-md-6 chatbox-input-text'>
                            <div className='comniq-box-shadow d-flex flex-column justify-content-center chatbox-input-field h-100 p-3'>
                              <label className='widget-label outfit-medium d-flex align-items-center gap-2'>
                                <img src={SLIDE_TIMER_ICON} alt='slide-timer-icon' /> Slider Timer (seconds)
                              </label>
                              <input
                                type='number'
                                className={`form-control chatbox-input box-shadow-hover ${!popup_status ? 'cursor-not-allowed' : ''}`}
                                name='timer_count'
                                value={timer_count}
                                autoComplete='off'
                                onChange={userHandleChange}
                                disabled={!popup_status}
                                min='0'
                              />
                            </div>
                          </div>
                          <div className='col-12 col-md-6 chatbox-input-text'>
                            <div className='comniq-box-shadow d-flex flex-column justify-content-center chatbox-input-field h-100 p-3'>
                              <label className='outfit-medium d-flex justify-content-between'>
                                <span>Chatbot Slider Size </span>
                                <span className='color-theme-cerisePink outfit-bold'> {chatbot_slider_size || 0}px</span>
                              </label>
                              <input
                                type='range'
                                className='custom-range-slider'
                                name='chatbot_slider_size'
                                value={chatbot_slider_size}
                                min='0'
                                max='1500'
                                step='1'
                                onChange={userHandleChange}
                              />
                            </div>
                          </div>
                          <div className='col-12 col-md-6 chatbox-input-text'>
                            <div className='comniq-box-shadow d-flex flex-column justify-content-center chatbox-input-field h-100 p-3 input-GPT new'>
                              <label className='outfit-medium'>Bot Position</label>
                              <div className='chatbox-input-field'>
                                <select className='form-control box-shadow-hover outfit-regular' name='chatbot_position' value={chatbot_position} onChange={userHandleChange}>
                                  <option selected hidden>
                                    Choose the Position
                                  </option>
                                  <option value='bottom-right'>Bottom Right</option>
                                  <option value='bottom-left'>Bottom Left</option>
                                  <option value='top-right'>Top Right</option>
                                  <option value='top-left'>Top Left</option>
                                  <option value='middle-top'>Middle Top</option>
                                  <option value='middle-bottom'>Middle Bottom</option>
                                  <option value='right-center'>Right Center</option>
                                  <option value='middle-center'>Middle Center</option>
                                  <option value='left-center'>Left Center</option>
                                </select>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className='mb-4 chatbox-input-text'>
                          <label className='widget-label outfit-medium d-flex align-items-center gap-2'>
                            <img src={WEBSITE_PREVIEW_ICON} alt='slide-timer-icon' /> Website To Preview On
                          </label>
                          <div className='comniq-box-shadow chatbox-input-field'>
                            <input
                              type='text'
                              defaultValue='https://www.lendaly.com.au/'
                              placeholder='https://www.example.com'
                              name='website'
                              value={website}
                              className='form-control chatbox-input box-shadow-hover'
                              onChange={userHandleChange}
                            />
                          </div>
                        </div>
                        <div className='knowledge-hub chatbox-input-text p-4 mb-4'>
                          <h6 className='outfit-bold bubbles-heading-text'>Input Customization</h6>
                          <div className='row g-5 align-items-center'>
                            <div className='col-12 col-md-4'>
                              <p className='outfit-medium bubbles-text'>Background Color</p>
                              <div className='d-flex align-items-center gap-2'>
                                <input type='color' name='chat_input_bgcolor' value={chat_input_bgcolor} className='form-control form-control-color' onChange={userHandleChange} />
                                <p className='outfit-regular mb-0 form-control-color-text'>{chat_input_bgcolor || '#000000'}</p>
                              </div>
                            </div>
                            <div className='col-12 col-md-4'>
                              <p className='outfit-medium bubbles-text'>Icon Color</p>
                              <div className='d-flex align-items-center gap-2'>
                                <input
                                  type='color'
                                  name='chat_input_icon_color'
                                  value={chat_input_icon_color}
                                  className='form-control form-control-color'
                                  onChange={userHandleChange}
                                />
                                <p className='outfit-regular mb-0 form-control-color-text'>{chat_input_icon_color || '#000000'}</p>
                              </div>
                            </div>
                            <div className='col-12 col-md-4'>
                              <p className='outfit-medium bubbles-text'>Font Color</p>
                              <div className='d-flex align-items-center gap-2'>
                                <input
                                  type='color'
                                  name='chat_input_font_color'
                                  value={chat_input_font_color}
                                  className='form-control form-control-color'
                                  onChange={userHandleChange}
                                />
                                <p className='outfit-regular mb-0 form-control-color-text'>{chat_input_font_color || '#000000'}</p>
                              </div>
                            </div>
                            <div className='col-12 col-md-4'>
                              <div className='d-flex flex-column justify-content-center'>
                                <label className='outfit-medium d-flex justify-content-between'>
                                  <span className='outfit-medium'>Font Size</span>
                                  <span className='color-theme-cerisePink outfit-bold'> {chat_input_fontsize || 0}px</span>
                                </label>
                                <input
                                  type='range'
                                  className='custom-range-slider'
                                  name='chat_input_fontsize'
                                  value={chat_input_fontsize || 0}
                                  min='0'
                                  max='20'
                                  step='1'
                                  onChange={userHandleChange}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                    {activeChildTab === 'Header' && (
                      <div className='widget-chatbot-body'>
                        <h6 className='outfit-semibold my-3 widget-body-text'>
                          <img src={HEADERPART_ICON} alt='header-icon' className='me-2' />
                          Header Part
                        </h6>
                        <div className='comniq-box-shadow mb-4'>
                          <label className='outfit-semibold mb-2'>Logo</label>

                          <div className='row gy-4 chatbox-input-text'>
                            <div className='col-12 col-md-6'>
                              <div className='d-flex flex-column flex-md-row align-items-center gap-3'>
                                <div className='logo-upload' onClick={() => document.getElementById('logoInput').click()}>
                                  {logoPreview || chatbot_logo ? <img src={logoPreview || chatbot_logo} alt='preview' /> : <img src={UPLOAD_ICON} alt='upload-icon' />}
                                </div>
                                <input type='file' accept='image/*' id='logoInput' style={{ display: 'none' }} onChange={(e) => logoIconHandleChange(e)} />

                                <div className='flex-grow-1'>
                                  <button className='widget-upload-button outfit-regular' onClick={() => document.getElementById('logoInput').click()}>
                                    Upload Logo
                                  </button>
                                  <div className='outfit-regular bubbles-text m-0'>
                                    JPG, PNG, GIF, SVG, WEBP
                                    <br />
                                    Max: 5mb
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className='col-12 col-md-6 mb-3'>
                              <div className='chatbox-input-field'>
                                <label className='outfit-medium d-flex justify-content-between'>
                                  <span>Logo Size</span>
                                  <span className='color-theme-cerisePink outfit-bold'> {header_logo_size || 0}px</span>
                                </label>
                                <input
                                  type='range'
                                  className='custom-range-slider'
                                  name='header_logo_size'
                                  value={header_logo_size || 0}
                                  min='0'
                                  max='250'
                                  step='1'
                                  onChange={userHandleChange}
                                />
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* <div className='comniq-box-shadow chatbox-input-text p-3 mb-4'>
                          <h6 className='outfit-semibold mb-3'>Heading</h6>
                          <div className='row'>
                            <div className='col-12 col-md-4 mb-3'>
                              <div className='chatbox-input-field'>
                                <label className='outfit-medium'>Text</label>
                                <input
                                  type='text'
                                  className='form-control chatbox-input box-shadow-hover'
                                  name='heading'
                                  value={heading}
                                  autoComplete='off'
                                  onChange={userHandleChange}
                                />
                                <small className='text-muted mt-1 d-block'>This text will appear at the top of your chat window</small>
                              </div>
                            </div>

                            <div className='col-12 col-md-4 mb-3'>
                              <p className='outfit-medium bubbles-text'>Text Color</p>
                              <div className='d-flex align-items-center gap-2'>
                                <input type='color' name='heading_font_color' value={heading_font_color} className='form-control form-control-color' onChange={userHandleChange} />
                                <p className='outfit-regular mb-0 form-control-color-text'>{heading_font_color}</p>
                              </div>
                            </div>

                            <div className='col-12 col-md-4 mb-3'>
                              <div className='chatbox-input-field'>
                                <label className='outfit-medium d-flex justify-content-between'>
                                  <span>Font Size</span>
                                  <span className='color-theme-cerisePink outfit-bold'>{heading_font_size}px</span>
                                </label>
                                <input
                                  type='range'
                                  className='custom-range-slider'
                                  name='heading_font_size'
                                  value={heading_font_size}
                                  min='0'
                                  max='20'
                                  step='1'
                                  onChange={userHandleChange}
                                />
                                <small className='text-muted mt-1 d-block'>Drag to set the font size for the heading</small>
                              </div>
                            </div>
                          </div>
                        </div> */}
                      </div>
                    )}
                    {activeChildTab === 'Bubbles' && (
                      <div className='widget-chatbot-body'>
                        <h6 className='outfit-semibold my-3 widget-body-text'>
                          <img src={BUBBLESPART_ICON} alt='header-icon' className='me-2' />
                          Bubbles Part
                        </h6>

                        <div className='knowledge-hub p-4 mb-4'>
                          <h6 className='outfit-bold bubbles-heading-text'>Agent Avatar</h6>
                          <div className='row gy-4 align-items-center chatbox-input-text'>
                            <div className='col-12 col-md-6'>
                              <div className='d-flex align-items-center gap-3'>
                                <div className='avatar-upload' id='avatarPreview' onClick={() => document.getElementById('newProfilePhoto').click()}>
                                  {avatarPreview ? (
                                    <img id='profilePic' className='pic' src={avatarPreview} alt='profile-img' />
                                  ) : (
                                    <img id='profilePic' className='pic' src={chatbot_avtar} alt='profile-img' />
                                  )}
                                </div>
                                <input type='file' name='chatbot_avtar' id='newProfilePhoto' accept='image/*' className='d-none' onChange={userHandleChange} />

                                <div className='flex-grow-1'>
                                  <button className='widget-upload-button outfit-regular' onClick={() => document.getElementById('newProfilePhoto').click()}>
                                    Upload Avatar
                                  </button>
                                  <p className='outfit-regular bubbles-text m-0'>JPG, PNG Max: 5mb</p>
                                </div>
                              </div>
                            </div>
                            <div className='col-12 col-md-6 mb-3'>
                              <div className='chatbox-input-field'>
                                <label className='outfit-medium d-flex justify-content-between'>
                                  <span>Avatar Size</span>
                                  <span className='color-theme-cerisePink outfit-bold'> {bubble_avatar_size || 0}px</span>
                                </label>
                                <input
                                  type='range'
                                  className='custom-range-slider'
                                  name='bubble_avatar_size'
                                  value={bubble_avatar_size || 0}
                                  min='0'
                                  max='100'
                                  step='1'
                                  onChange={userHandleChange}
                                />
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className='knowledge-hub chatbox-input-text p-4 mb-4'>
                          <h6 className='outfit-bold bubbles-heading-text'>Agent Message Bubbles</h6>
                          <div className='row g-3 align-items-center'>
                            <div className='col-md-4 col-12'>
                              <p className='outfit-medium bubbles-text'>Background Color</p>
                              <div className='d-flex align-items-center gap-2'>
                                <input type='color' id='agentBgColor' name='color' value={color} className='form-control form-control-color' onChange={userHandleChange} />
                                <p className='outfit-regular mb-0 form-control-color-text'>{color}</p>
                              </div>
                            </div>
                            <div className='col-md-4 col-12'>
                              <p className='outfit-medium bubbles-text'>Text Color</p>
                              <div className='d-flex align-items-center gap-2'>
                                <input
                                  type='color'
                                  name='agent_bubble_text_color'
                                  className='form-control form-control-color'
                                  value={agent_bubble_text_color}
                                  onChange={userHandleChange}
                                />
                                <p className='outfit-regular mb-0 form-control-color-text'>{agent_bubble_text_color}</p>
                              </div>
                            </div>
                            <div className='col-12 col-md-4'>
                              <div className='chatbox-input-field'>
                                <label className='outfit-medium d-flex justify-content-between'>
                                  <span>Font Size</span>
                                  <span className='color-theme-cerisePink outfit-bold'> {agent_bubble_font_size || 0}px</span>
                                </label>
                                <input
                                  type='range'
                                  className='custom-range-slider'
                                  name='agent_bubble_font_size'
                                  value={agent_bubble_font_size || 0}
                                  min='0'
                                  max='20'
                                  step='1'
                                  onChange={userHandleChange}
                                />
                              </div>
                            </div>
                          </div>
                          <div className='comniq-box-shadow d-flex align-items-start gap-2 p-3 mt-3'>
                            <div className='avatar-upload' style={{ width: '25px', height: '25px' }}>
                              {avatarPreview ? (
                                <img id='profilePic' className='pic' src={avatarPreview} alt='profile-img' />
                              ) : (
                                <img id='profilePic' className='pic' src={chatbot_avtar} alt='profile-img' />
                              )}
                            </div>
                            <div className='preview-bubble-left outfit-regular' id='agentBubble' style={{ backgroundColor: color, color: agent_bubble_text_color }}>
                              This is how the agent's messages will appear
                            </div>
                          </div>
                        </div>

                        <div className='knowledge-hub chatbox-input-text p-4 mb-4'>
                          <h6 className='outfit-bold bubbles-heading-text'>User Message Bubbles</h6>
                          <div className='row g-3 align-items-center'>
                            <div className='col-md-4 col-12'>
                              <p className='outfit-medium bubbles-text'>Background Color</p>
                              <div className='d-flex align-items-center gap-2'>
                                <input
                                  type='color'
                                  id='userBgColor'
                                  name='client_bubble_color'
                                  value={client_bubble_color}
                                  className='form-control form-control-color'
                                  onChange={userHandleChange}
                                />
                                <p className='outfit-regular mb-0 form-control-color-text'>{client_bubble_color}</p>
                              </div>
                            </div>
                            <div className='col-md-4 col-12'>
                              <p className='outfit-medium bubbles-text'>Text Color</p>
                              <div className='d-flex align-items-center gap-2'>
                                <input
                                  type='color'
                                  id='userTextColor'
                                  name='bubble_text_color'
                                  value={bubble_text_color}
                                  className='form-control form-control-color'
                                  onChange={userHandleChange}
                                />
                                <p className='outfit-regular mb-0 form-control-color-text'>{bubble_text_color}</p>
                              </div>
                            </div>
                            <div className='col-12 col-md-4'>
                              <div className='chatbox-input-field'>
                                <label className='outfit-medium d-flex justify-content-between'>
                                  <span>Font Size</span>
                                  <span className='color-theme-cerisePink outfit-bold'> {user_bubble_font_size || 0}px</span>
                                </label>
                                <input
                                  type='range'
                                  className='custom-range-slider'
                                  name='user_bubble_font_size'
                                  value={user_bubble_font_size || 0}
                                  min='0'
                                  max='20'
                                  step='1'
                                  onChange={userHandleChange}
                                />
                              </div>
                            </div>
                          </div>
                          <div className='comniq-box-shadow d-flex justify-content-end p-3 mt-3'>
                            <div className='preview-bubble-right outfit-regular' id='userBubble' style={{ backgroundColor: client_bubble_color, color: bubble_text_color }}>
                              This is how user messages will appear
                            </div>
                          </div>
                        </div>
                        <div className='knowledge-hub chatbox-input-text p-4 mb-4'>
                          <h6 className='outfit-bold bubbles-heading-text'>Popup Bubble Customization</h6>
                          <div className='row g-5 align-items-center'>
                            <div className='col-12 col-md-4'>
                              <div className='d-flex flex-column justify-content-center'>
                                <label className='outfit-medium d-flex justify-content-between'>
                                  <span className='outfit-medium'>Bubble Width</span>
                                  <span className='color-theme-cerisePink outfit-bold'> {bubble_width || 0}px</span>
                                </label>
                                <input
                                  type='range'
                                  className='custom-range-slider'
                                  name='bubble_width'
                                  value={bubble_width || 0}
                                  min='0'
                                  max='1000'
                                  step='1'
                                  onChange={userHandleChange}
                                />
                              </div>
                            </div>
                            <div className='col-12 col-md-4'>
                              <div className='d-flex flex-column justify-content-center'>
                                <label className='outfit-medium d-flex justify-content-between'>
                                  <span className='outfit-medium'>Bubble Height</span>
                                  <span className='color-theme-cerisePink outfit-bold'> {bubble_height || 0}px</span>
                                </label>
                                <input
                                  type='range'
                                  className='custom-range-slider'
                                  name='bubble_height'
                                  value={bubble_height || 0}
                                  min='0'
                                  max='1000'
                                  step='1'
                                  onChange={userHandleChange}
                                />
                              </div>
                            </div>
                            <div className='col-12 col-md-4'>
                              <div className='d-flex flex-column justify-content-center'>
                                <label className='outfit-medium d-flex justify-content-between'>
                                  <span className='outfit-medium'>Button Width</span>
                                  <span className='color-theme-cerisePink outfit-bold'> {bubble_button_width || 0}px</span>
                                </label>
                                <input
                                  type='range'
                                  className='custom-range-slider'
                                  name='bubble_button_width'
                                  value={bubble_button_width || 0}
                                  min='0'
                                  max='1000'
                                  step='1'
                                  onChange={userHandleChange}
                                />
                              </div>
                            </div>
                            <div className='col-12 col-md-4'>
                              <div className='d-flex flex-column justify-content-center'>
                                <label className='outfit-medium d-flex justify-content-between'>
                                  <span className='outfit-medium'>Button Height</span>
                                  <span className='color-theme-cerisePink outfit-bold'> {bubble_button_height || 0}px</span>
                                </label>
                                <input
                                  type='range'
                                  className='custom-range-slider'
                                  name='bubble_button_height'
                                  value={bubble_button_height || 0}
                                  min='0'
                                  max='1000'
                                  step='1'
                                  onChange={userHandleChange}
                                />
                              </div>
                            </div>

                            <div className='col-12 col-md-4'>
                              <div className='d-flex flex-column justify-content-center'>
                                <label className='d-flex justify-content-between outfit-medium '>
                                  <span className='outfit-medium'>Text Font Size</span>
                                  <span className='color-theme-cerisePink outfit-bold'> {bubble_text_size || 0}px</span>
                                </label>
                                <input
                                  type='range'
                                  className='custom-range-slider'
                                  name='bubble_text_size'
                                  value={bubble_text_size || 0}
                                  min='0'
                                  max='30'
                                  step='1'
                                  onChange={userHandleChange}
                                />
                              </div>
                            </div>
                            <div className='col-12 col-md-4'>
                              <p className='outfit-medium bubbles-text'>Text Font Color</p>
                              <div className='d-flex align-items-center gap-2'>
                                <input
                                  type='color'
                                  id='userBgColor'
                                  name='text_color_bubble'
                                  value={text_color_bubble}
                                  className='form-control form-control-color'
                                  onChange={userHandleChange}
                                />
                                <p className='outfit-regular mb-0 form-control-color-text'>{text_color_bubble || '#000000'}</p>
                              </div>
                            </div>
                            <div className='col-12 col-md-4'>
                              <p className='outfit-medium bubbles-text'>Bubble Background Color</p>
                              <div className='d-flex align-items-center gap-2'>
                                <input
                                  type='color'
                                  id='userBgColor'
                                  name='bubble_bg_color'
                                  value={bubble_bg_color}
                                  className='form-control form-control-color'
                                  onChange={userHandleChange}
                                />
                                <p className='outfit-regular mb-0 form-control-color-text'>{bubble_bg_color || '#000000'}</p>
                              </div>
                            </div>

                            {!isFreePlan && (
                              <>
                                <div className='col-12 col-md-4'>
                                  <p className='outfit-medium bubbles-text'>First Button BG Color</p>
                                  <div className='color-input-wrapper d-flex align-items-center gap-2'>
                                    <input
                                      type='color'
                                      id='userBgColor'
                                      name='btn_primary_bg'
                                      value={btn_primary_bg}
                                      className='form-control form-control-color'
                                      onChange={userHandleChange}
                                    />
                                    <p className='outfit-regular mb-0 form-control-color-text'>{btn_primary_bg || '#000000'}</p>
                                  </div>
                                </div>
                                <div className='col-12 col-md-4'>
                                  <p className='outfit-medium bubbles-text'>First Button Text Color</p>
                                  <div className='d-flex align-items-center gap-2'>
                                    <input
                                      type='color'
                                      id='userBgColor'
                                      name='btn_primary_text'
                                      value={btn_primary_text}
                                      className='form-control form-control-color'
                                      onChange={userHandleChange}
                                    />
                                    <p className='outfit-regular mb-0 form-control-color-text'>{btn_primary_text || '#000000'}</p>
                                  </div>
                                </div>
                                <div className='col-12 col-md-4'>
                                  <p className='outfit-medium bubbles-text'>Second Button BG Color</p>
                                  <div className='d-flex align-items-center gap-2'>
                                    <input
                                      type='color'
                                      id='userBgColor'
                                      name='btn_secondary_bg'
                                      value={btn_secondary_bg}
                                      className='form-control form-control-color'
                                      onChange={userHandleChange}
                                    />
                                    <p className='outfit-regular mb-0 form-control-color-text'>{btn_secondary_bg || '#000000'}</p>
                                  </div>
                                </div>
                                <div className='col-12 col-md-4'>
                                  <p className='outfit-medium bubbles-text'>Second Button Text Color</p>
                                  <div className='d-flex align-items-center gap-2'>
                                    <input
                                      type='color'
                                      id='userBgColor'
                                      name='btn_secondary_text'
                                      value={btn_secondary_text}
                                      className='form-control form-control-color'
                                      onChange={userHandleChange}
                                    />
                                    <p className='outfit-regular mb-0 form-control-color-text'>{btn_secondary_text || '#000000'}</p>
                                  </div>
                                </div>
                              </>
                            )}
                          </div>
                        </div>
                        <div className='knowledge-hub chatbox-input-text p-4 mb-4'>
                          <h6 className='outfit-bold bubbles-heading-text'>Welcome Slider Customization</h6>
                          <div className='row g-5 align-items-center'>
                            <div className='col-12 col-md-4'>
                              <div className='d-flex flex-column justify-content-center'>
                                <label className='outfit-medium d-flex justify-content-between'>
                                  <span className='outfit-medium'>Bubble Width</span>
                                  <span className='color-theme-cerisePink outfit-bold'> {inside_bubble_width}px</span>
                                </label>
                                <input
                                  type='range'
                                  className='custom-range-slider'
                                  name='inside_bubble_width'
                                  value={inside_bubble_width}
                                  min='0'
                                  max='1000'
                                  step='1'
                                  onChange={userHandleChange}
                                />
                              </div>
                            </div>
                            <div className='col-12 col-md-4'>
                              <div className='d-flex flex-column justify-content-center'>
                                <label className='outfit-medium d-flex justify-content-between'>
                                  <span className='outfit-medium'>Bubble Height</span>
                                  <span className='color-theme-cerisePink outfit-bold'> {inside_bubble_height}px</span>
                                </label>
                                <input
                                  type='range'
                                  className='custom-range-slider'
                                  name='inside_bubble_height'
                                  value={inside_bubble_height}
                                  min='0'
                                  max='1000'
                                  step='1'
                                  onChange={userHandleChange}
                                />
                              </div>
                            </div>
                            <div className='col-12 col-md-4'>
                              <div className='d-flex flex-column justify-content-center'>
                                <label className='outfit-medium d-flex justify-content-between'>
                                  <span className='outfit-medium'>Button Width</span>
                                  <span className='color-theme-cerisePink outfit-bold'> {inside_bubble_button_width}px</span>
                                </label>
                                <input
                                  type='range'
                                  className='custom-range-slider'
                                  name='inside_bubble_button_width'
                                  value={inside_bubble_button_width}
                                  min='0'
                                  max='1000'
                                  step='1'
                                  onChange={userHandleChange}
                                />
                              </div>
                            </div>
                            <div className='col-12 col-md-4'>
                              <div className='d-flex flex-column justify-content-center'>
                                <label className='outfit-medium d-flex justify-content-between'>
                                  <span className='outfit-medium'>Button Height</span>
                                  <span className='color-theme-cerisePink outfit-bold'> {inside_bubble_button_height || 0}px</span>
                                </label>
                                <input
                                  type='range'
                                  className='custom-range-slider'
                                  name='inside_bubble_button_height'
                                  value={inside_bubble_button_height || 0}
                                  min='0'
                                  max='1000'
                                  step='1'
                                  onChange={userHandleChange}
                                />
                              </div>
                            </div>

                            <div className='col-12 col-md-4'>
                              <div className='d-flex flex-column justify-content-center'>
                                <label className='d-flex justify-content-between outfit-medium '>
                                  <span className='outfit-medium'>Text Font Size</span>
                                  <span className='color-theme-cerisePink outfit-bold'> {inside_bubble_text_size || 0}px</span>
                                </label>
                                <input
                                  type='range'
                                  className='custom-range-slider'
                                  name='inside_bubble_text_size'
                                  value={inside_bubble_text_size || 0}
                                  min='0'
                                  max='30'
                                  step='1'
                                  onChange={userHandleChange}
                                />
                              </div>
                            </div>
                            <div className='col-12 col-md-4'>
                              <p className='outfit-medium bubbles-text'>Text Font Color</p>
                              <div className='d-flex align-items-center gap-2'>
                                <input
                                  type='color'
                                  id='userBgColor'
                                  name='inside_text_color_bubble'
                                  value={inside_text_color_bubble}
                                  className='form-control form-control-color'
                                  onChange={userHandleChange}
                                />
                                <p className='outfit-regular mb-0 form-control-color-text'>{inside_text_color_bubble || '#000000'}</p>
                              </div>
                            </div>
                            <div className='col-12 col-md-4'>
                              <p className='outfit-medium bubbles-text'>Bubble Background Color</p>
                              <div className='d-flex align-items-center gap-2'>
                                <input
                                  type='color'
                                  id='userBgColor'
                                  name='inside_bubble_bg_color'
                                  value={inside_bubble_bg_color}
                                  className='form-control form-control-color'
                                  onChange={userHandleChange}
                                />
                                <p className='outfit-regular mb-0 form-control-color-text'>{inside_bubble_bg_color || '#000000'}</p>
                              </div>
                            </div>
                            {!isFreePlan && (
                              <>
                                <div className='col-12 col-md-4'>
                                  <p className='outfit-medium bubbles-text'>First Button BG Color</p>
                                  <div className='d-flex align-items-center gap-2'>
                                    <input
                                      type='color'
                                      id='userBgColor'
                                      name='inside_btn_primary_bg'
                                      value={inside_btn_primary_bg}
                                      className='form-control form-control-color'
                                      onChange={userHandleChange}
                                    />
                                    <p className='outfit-regular mb-0 form-control-color-text'>{inside_btn_primary_bg || '#000000'}</p>
                                  </div>
                                </div>
                                <div className='col-12 col-md-4'>
                                  <p className='outfit-medium bubbles-text'>First Button Text Color</p>
                                  <div className='d-flex align-items-center gap-2'>
                                    <input
                                      type='color'
                                      id='userBgColor'
                                      name='inside_btn_primary_text'
                                      value={inside_btn_primary_text}
                                      className='form-control form-control-color'
                                      onChange={userHandleChange}
                                    />
                                    <p className='outfit-regular mb-0 form-control-color-text'>{inside_btn_primary_text || '#000000'}</p>
                                  </div>
                                </div>
                                <div className='col-12 col-md-4'>
                                  <p className='outfit-medium bubbles-text'>Second Button BG Color</p>
                                  <div className='d-flex align-items-center gap-2'>
                                    <input
                                      type='color'
                                      id='userBgColor'
                                      name='inside_btn_secondary_bg'
                                      value={inside_btn_secondary_bg}
                                      className='form-control form-control-color'
                                      onChange={userHandleChange}
                                    />
                                    <p className='outfit-regular mb-0 form-control-color-text'>{inside_btn_secondary_bg || '#000000'}</p>
                                  </div>
                                </div>
                                <div className='col-12 col-md-4'>
                                  <p className='outfit-medium bubbles-text'>Second Button Text Color</p>
                                  <div className='d-flex align-items-center gap-2'>
                                    <input
                                      type='color'
                                      id='userBgColor'
                                      name='inside_btn_secondary_text'
                                      value={inside_btn_secondary_text}
                                      className='form-control form-control-color'
                                      onChange={userHandleChange}
                                    />
                                    <p className='outfit-regular mb-0 form-control-color-text'>{inside_btn_secondary_text || '#000000'}</p>
                                  </div>
                                </div>
                              </>
                            )}
                          </div>
                        </div>
                      </div>
                    )}
                    {activeChildTab === 'Window' && (
                      <div className='widget-chatbot-body'>
                        <h6 className='outfit-semibold my-3 widget-body-text'>
                          <img src={WINDOW_ICON} alt='window-icon' className='me-2' />
                          Window Part
                        </h6>
                        <div className='comniq-box-shadow mb-4'>
                          <label className='outfit-semibold mb-2'>
                            Background Image
                            <div className='custom-tooltip-container'>
                              <img src={INFO_ICON} alt='info-icon' width='15' height='15' className='ms-1 cursor-pointer' />
                              <span className='custom-tooltip'>Please upload a mobile vertical-type image background.</span>
                            </div>
                          </label>
                          <div className='d-flex flex-column flex-md-row align-items-center gap-3'>
                            <div className='logo-upload' onClick={() => document.getElementById('newBackgroundImage').click()}>
                              {bgPreview ? (
                                <img id='profilePic' className='pic object-fit-cover' src={bgPreview} alt='profile-img' />
                              ) : bg_chatbot ? (
                                <img id='profilePic' className='pic object-fit-cover' src={bg_chatbot} alt='profile-img' />
                              ) : (
                                <div className='upload-icon-wrapper'>
                                  <FiUpload size={30} style={{ color: '#d1d5db' }} />
                                </div>
                              )}
                              {bg_chatbot !== null && companyData !== '' && (
                                <span
                                  className='bg-close'
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    setBgPopup(true);
                                  }}
                                >
                                  <RiCloseCircleLine />
                                </span>
                              )}
                            </div>
                            <input type='file' name='bg_chatbot' id='newBackgroundImage' accept='image/*' className='d-none' onChange={userBgImageChange} />

                            <div className='flex-grow-1'>
                              <button className='widget-upload-button outfit-regular' onClick={() => document.getElementById('newBackgroundImage').click()}>
                                Upload Image
                              </button>
                              <div className='outfit-regular bubbles-text m-0'>JPG, PNG • Max: 5mb</div>
                            </div>
                          </div>
                        </div>
                        <div className='comniq-box-shadow chatbox-input-text mb-4'>
                          <label className='outfit-semibold mb-2'>Window Colors</label>
                          <div className='row g-3 align-items-center'>
                            <div className='col-md-4 col-12'>
                              <p className='outfit-medium bubbles-text'>Background Color</p>
                              <div className='d-flex align-items-center gap-2'>
                                <input
                                  type='color'
                                  id='agentBgColor'
                                  name='background_color'
                                  value={background_color}
                                  className='form-control form-control-color'
                                  onChange={userHandleChange}
                                />
                                <p className='outfit-regular mb-0 form-control-color-text'>{background_color}</p>
                              </div>
                            </div>
                            <div className='col-12 col-md-4'>
                              <p className='outfit-medium bubbles-text'>Text Color</p>
                              <div className='d-flex align-items-center gap-2'>
                                <input type='color' name='text_color' className='form-control form-control-color' value={text_color} onChange={userHandleChange} />
                                <p className='outfit-regular mb-0 form-control-color-text'>{text_color}</p>
                              </div>
                            </div>
                            <div className='col-12 col-md-4'>
                              <div className='chatbox-input-field'>
                                <label className='outfit-medium d-flex justify-content-between'>
                                  <span>Font Size</span>
                                  <span className='color-theme-cerisePink outfit-bold'> {windo_font_size || 0}px</span>
                                </label>
                                <input
                                  type='range'
                                  className='custom-range-slider'
                                  name='windo_font_size'
                                  value={windo_font_size || 0}
                                  min='0'
                                  max='20'
                                  step='1'
                                  onChange={userHandleChange}
                                />
                              </div>
                            </div>
                            <div className='d-flex justify-content-start p-3 mt-3'>
                              <div className='rounded-3 outfit-regular p-2' id='userBubble' style={{ backgroundColor: background_color, color: text_color }}>
                                This is how user text will appear
                              </div>
                            </div>
                          </div>
                        </div>
                        {companyData !== '' && (
                          <div className='comniq-box-shadow mb-4'>
                            <h6 className='outfit-bold mb-3'>Chat Bubble Icon</h6>

                            <div className='row gy-4 align-items-center chatbox-input-text'>
                              <div className='col-12 col-md-6'>
                                <div className='d-flex align-items-center gap-3 mb-3'>
                                  <div className='avatar-upload' id='profilePicPreview'>
                                    <div className='upload-icon-wrapper' onClick={() => document.getElementById('fileInput').click()}>
                                      <FiUpload size={30} style={{ color: '#d1d5db' }} />
                                    </div>
                                  </div>
                                  <div>
                                    <input type='file' name='chatbot_avtar' id='fileInput' accept='image/*' className='d-none' onChange={(e) => launcherIconHandleChange(e)} />
                                    <div className='flex-grow-1'>
                                      <button className='widget-upload-button outfit-regular' onClick={() => document.getElementById('fileInput').click()}>
                                        Upload Icon
                                      </button>
                                      <div className='outfit-regular bubbles-text m-0'>
                                        JPG, PNG, GIF, SVG, WEBP <br /> Max: 5mb
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className='col-12 col-md-6 mb-3'>
                                <div className='chatbox-input-field'>
                                  <label className='outfit-medium d-flex justify-content-between'>
                                    <span>Icon Size</span>
                                    <span className='color-theme-cerisePink outfit-bold'> {chat_bubble_icon_size || 0}px</span>
                                  </label>
                                  <input
                                    type='range'
                                    className='custom-range-slider'
                                    name='chat_bubble_icon_size'
                                    value={chat_bubble_icon_size || 0}
                                    min='0'
                                    max='200'
                                    step='1'
                                    onChange={userHandleChange}
                                  />
                                </div>
                              </div>
                            </div>

                            <div className='mt-3'>
                              <label className='outfit-semibold mb-2 d-block'>Choose from available icons:</label>
                              <div className='d-flex flex-wrap align-items-center gap-3'>
                                {launcher_icon?.length > 0 && (
                                  <div className={`chatboxupdate-logo ${launcher_icon_status ? 'active' : ''}`}>
                                    <img src={launcher_icon} alt='Selected Icon' className='launcher-icon' style={{ width: '100%', height: '100%', borderRadius: '8px' }} />
                                  </div>
                                )}

                                {default_launcher_icon?.length > 0 &&
                                  default_launcher_icon.map((image, index) => (
                                    <div key={index} className={`chatboxupdate-logo ${image.status ? 'active' : ''}`} onClick={() => LauncherIconChange(image, index)}>
                                      <img src={image.link} alt='chatbox-icon' className='launcher-icon' />
                                    </div>
                                  ))}
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    )}

                    <div className='d-flex flex-wrap justify-content-end gap-2'>
                      <button className='btn-delete outfit-medium' type='button' onClick={() => resetChatbotWidget()}>
                        Reset Chatbot
                      </button>
                      <button className='btn-add-faq outfit-medium' type='button' onClick={() => handleNavigatePreview()}>
                        Preview
                      </button>
                      <button className='chatbot-save-btn d-flex align-items-center gap-2' onClick={UpdateChatBotData}>
                        <img src={SAVE_ICON} alt='save-icon' /> Save Changes
                      </button>
                    </div>
                  </div>
                </>
              )}

              {activeTab === 'embed' && (
                <div className=' my-4'>
                  <div className='card-body'>
                    <div className='mb-3'>
                      <label className='form-label outfit-semibold mb-3'>Have you connected your agent to your site using the code snippet below?</label>
                      <div className='d-flex align-items-center gap-3'>
                        <div className='d-flex gap-2'>
                          <button
                            className={`btn btn-md ${is_script_ingrate === 'true' ? 'btn-success' : 'btn-outline-success'}`}
                            onClick={() => (website ? setShowWarning(true) : toast.error('Please enter a website Link'))}
                          >
                            Yes
                          </button>
                          <button
                            className={`btn btn-md ${is_script_ingrate === 'false' ? 'btn-danger' : 'btn-outline-danger'}`}
                            onClick={(e) => {
                              UpdateChatBotData(e, 'is_script_ingrate', false);
                              setShowWarning(false);
                            }}
                          >
                            No
                          </button>
                        </div>
                      </div>
                    </div>

                    {is_script_ingrate !== null && (
                      <div className='d-flex flex-wrap align-items-center gap-2'>
                        {subscriptionName != null && (
                          <button className='widget-upload-button d-flex align-items-center' type='button' onClick={() => copyToClipboard()}>
                            <FiUpload size={16} className='me-2' />
                            <span className='outfit-medium'>Share Website Test</span>
                          </button>
                        )}
                        <div className='widget-upload-button d-flex align-items-center justify-content-between p-2 gap-2'>
                          <button className='btn btn-sm flex-grow-1 outfit-medium no-border-shadow' type='button' onClick={() => handleShareLeadPreview()}>
                            Use for ads link
                          </button>

                          <button className='btn btn-light border btn-sm d-flex align-items-center justify-content-center' id='basic-addon2' onClick={() => copyToLeadClipboard()}>
                            {!copyLeadSuccess ? <MdContentCopy size={16} /> : <AiOutlineCheck size={16} />}
                          </button>
                        </div>
                      </div>
                    )}
                    {subscriptionName != null && <hr />}

                    {subscriptionName != null && (
                      <div className='embed-code-box comniq-box-shadow p-3 mb-3'>
                        <h6 className='outfit-semibold'>ComniqAI Widget Instructions</h6>
                        <div className='knowledge-hub d-flex align-items-center p-2 mb-3 position-relative'>
                          {widgetCode !== '' && (
                            <textarea
                              type='text'
                              className='form-control'
                              placeholder="Recipient's username"
                              aria-label="Recipient's username"
                              aria-describedby='basic-addon2'
                              value={widgetCode}
                              disabled
                            />
                          )}
                          <button
                            className='btn btn-light border btn-md d-flex align-items-center justify-content-center position-absolute top-0 end-0 m-2'
                            onClick={handleCopyText}
                          >
                            {!copySuccess ? <MdContentCopy /> : <AiOutlineCheck />}
                          </button>
                        </div>
                        <div className='p-2'>
                          <p className='outfit-regular mb-1'>
                            <strong>Please begin by following these basic steps:</strong>
                          </p>
                          <p className='outfit-regular mb-3'>Follow the provided instructions to customize your Chatbot and complete all the necessary processes.</p>
                          <ul className='mb-3 ps-3'>
                            <li>Click the "save button" to generate the widget script and copy the code provided.</li>
                            <li>Once the steps are completed, preview any updates or modifications by clicking the preview button.</li>
                            <li>Please note that some websites may not display the preview correctly.</li>
                            <li>Navigate to your website and open the HTML file using a text editor.</li>
                            <li>{'Find the </head> tag and paste the code snippet just before it. Save the HTML file.'}</li>
                            <li>
                              Refresh your website, and you should now see the Chatbot visible, usually appearing as a symbol or icon in the bottom right corner of the webpage.
                            </li>
                          </ul>
                        </div>
                        <div className='important-note alert alert-warning small mb-0'>
                          <strong>IMPORTANT NOTE:</strong> It is important to note that modifying your website's code, especially if you are not familiar with the code, can cause
                          issues with your website. Be sure to test the changes and make a backup of your website before making any code modifications.
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>
            <WidgetChatbot key={`${widgetValues?.id}-${refreshTrigger}`} widgetAllData={widgetValues} widgetID={widgetValues?.id} refresh={refreshTrigger} />
          </div>
        </div>
      </div>

      {loader && (
        <div className='loader-center'>
          <Loader />
        </div>
      )}
      {bgPopup && (
        <div className='custom-popup'>
          <div className='popup-content'>
            <h4 className='outfit-bold'>Are you sure you want to delete?</h4>
            <hr />
            <div className='popup-footer d-flex align-items-center gap-2'>
              <button className='btn-modal-save outfit-medium bg-danger border-0' onClick={() => handleBgDelete()}>
                Delete
              </button>
              <button className='btn-modal-cancel outfit-medium' data-dismiss='modal' onClick={() => setBgPopup(false)}>
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
      {faqPopup && (
        <div className='custom-popup'>
          <div className='popup-content text-center'>
            <h4 className='outfit-bold'>Don't forget to see how well ComniqAI generated your knowledge hub with its amazing customized training.</h4>
            <hr />
            <div className='popup-footer text-center'>
              <button
                className='btn-modal-save outfit-medium bg-theme-gradientBlue border-0'
                style={{ border: 'none' }}
                onClick={() => Navigate('/chatbot/websitescrape', { state: { faqFlag: true, id: state?.id, length: state?.length } })}
              >
                View Knowledge-Hub
              </button>
              <button
                className='btn-modal-cancel outfit-medium'
                data-dismiss='modal'
                onClick={() => {
                  setFaqPopup(false);
                  Navigate('/chatbot/customizewidget', { state: null });
                }}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
      {showWarning && (
        <div className='custom-popup'>
          <div className='popup-content'>
            <h4 className='outfit-bold text-center'>Warning ⚠️</h4>
            <hr />
            <p className='outfit-regular mb-0'>
              Trying to share your agent on social media or to someone won't show your company url unless you have connected your agent to your site. You can still share your agent
              to socials and friends by ticking NO however it will have chirplo.(url) will be shown in adress bar. Are you sure you want to continue
            </p>
            <hr />
            <div className='popup-footer d-flex align-items-center justify-content-center gap-2'>
              <button
                className='btn-modal-save outfit-medium bg-danger border-0'
                onClick={(e) => {
                  UpdateChatBotData(e, 'is_script_ingrate', true);
                  setShowWarning(false);
                }}
              >
                Ok
              </button>
              <button className='btn-modal-cancel outfit-medium' onClick={() => setShowWarning(false)}>
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
      {showPublishPopup && isFreePlan && (
        <div className='custom-popup'>
          <div className='popup-content'>
            <h4 className='outfit-bold'>Your changes are ready to go live. 🚀</h4>
            <hr />
            <p className='outfit-regular mb-0'>Click Publish to make these updates available for testing and for all public users.</p>
            <hr />
            <div className='popup-footer d-flex align-items-center gap-2'>
              <button className='btn-modal-save outfit-medium bg-success border-0' disabled={isPublishing} onClick={() => publishChatbotData(apiTokenData)}>
                {isPublishing ? 'Publishing...' : 'Publish'}
              </button>
              <button className='btn-modal-cancel outfit-medium' onClick={() => setShowPublishPopup(false)}>
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default CustomizeWidget;
